import { useEffect, useRef } from 'react';
import { useReducedMotion } from 'framer-motion';

const CursorGlow = () => {
  const ref = useRef(null);
  const reduceMotion = useReducedMotion();

  useEffect(() => {
    if (reduceMotion) return undefined;
    const el = ref.current;
    if (!el) return undefined;

    const handler = (e) => {
      el.style.setProperty('--glow-x', `${e.clientX}px`);
      el.style.setProperty('--glow-y', `${e.clientY}px`);
      
      // Make coordinates globally available for other effects (like Spotlight)
      document.documentElement.style.setProperty('--mouse-x', `${e.clientX}px`);
      document.documentElement.style.setProperty('--mouse-y', `${e.clientY}px`);
    };

    window.addEventListener('pointermove', handler, { passive: true });
    return () => window.removeEventListener('pointermove', handler);
  }, [reduceMotion]);

  if (reduceMotion) return null;

  return <div ref={ref} className="landing-cursor-glow" aria-hidden="true" />;
};

export default CursorGlow;
